export const clearStorage = () =>  localStorage.clear();
export const getToken = () => localStorage.getItem('token');
export const setToken = token => localStorage.setItem('token', token);
export const setUser = user => localStorage.setItem('token', JSON.stringify(user));
export const getUser = () => JSON.parse(localStorage.getItem('user'));
